export default __webpack_public_path__ + "static/media/logo-sm.721cd0f7.png";